import { render, staticRenderFns } from "./phiFormulaInner.vue?vue&type=template&id=a2560f10&"
import script from "./phiFormulaInner.vue?vue&type=script&lang=ts&"
export * from "./phiFormulaInner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports